import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";

export default class extends ApplicationController {

  static targets = ["hm0_output"];
  connect() {
    super.connect();
  }
    
  get current_app() {
    return this.data.get("app");
  }
  get entreprise_id() {
    return this.data.get("entrepriseid");
  }
  get url_solution() {
    return this.data.get("urlsolution");
  }
}
